import { UploadedDocumentTypeGQLType } from '../../../../../types/dashboard-core-gqlTypes.generated.d';

/** **************** DOCUMENT UPLOAD TYPE ****************** */
export const UPLOADED_DOCUMENT_TYPE_TO_LABEL: Record<
  UploadedDocumentTypeGQLType,
  string
> = {
  participationAgreement: 'Participation Agreement',
  creditAgreement: 'Credit Agreement',
};
